// Generic stub page — informative placeholder that lists what will go there.
// Mounted into Shop / Virtual Land / Governance / Registry / Overview.

export function mountStubPage({ root, title, subtitle, sections }) {
  root.innerHTML = `
    <div class="page-stub">
      <h1>${title}</h1>
      <p class="page-stub-sub">${subtitle}</p>
      <div class="page-stub-grid">
        ${sections
          .map(
            (s) => `
          <div class="page-stub-card">
            <div class="page-stub-card-title">${s.title}</div>
            <p>${s.desc}</p>
            <div class="page-stub-card-status">${s.status ?? 'Coming soon'}</div>
          </div>
        `,
          )
          .join('')}
      </div>
    </div>
  `
}
